<nav id="footerid" class="footer-global">
    <div>
        <span class="footer-link-global footer-link-color-gray float-left">Copyrighted © 2025</span>

        <span class="footer-link-global footer-link-color-blue float-right">PRIVACY POLICY</span>
        <span class="footer-link-separator float-right">|</span>
        <span class="footer-link-global footer-link-color-blue float-right">CONTACT US</span>
        <span class="footer-link-separator float-right">|</span>
        <span class="footer-link-global footer-link-color-blue float-right">TERMS OF USE</span>
        <span class="footer-link-separator float-right">|</span>
        <span class="footer-link-global footer-link-color-blue float-right" style="cursor: pointer;" >FAQs</span>
    </div>
</nav>